import { LEGAL_DOCUMENT_VERSION } from '@/config/legal';

/**
 * Принятие Условий и Политики при первом запуске.
 *
 * Хранится на устройстве вместе с версией документов: новая редакция
 * (LEGAL_DOCUMENT_VERSION) снова показывает экран принятия. Это допуск к
 * интерфейсу, а не юридическое доказательство — доказательством служит серверная
 * отметка согласия на фото (CONSENT_VERSION). Любой сбой хранилища для
 * человека не ошибка: экран покажется снова при следующем запуске.
 */
export const TERMS_ACCEPTANCE_STORAGE_KEY = 'astra-terms-accepted';

export function hasAcceptedTerms(): boolean {
  try {
    return window.localStorage.getItem(TERMS_ACCEPTANCE_STORAGE_KEY) === LEGAL_DOCUMENT_VERSION;
  } catch {
    return false;
  }
}

export function writeTermsAcceptance(): void {
  try {
    window.localStorage.setItem(TERMS_ACCEPTANCE_STORAGE_KEY, LEGAL_DOCUMENT_VERSION);
  } catch {
    // Хранилище недоступно — принятие действует до закрытия приложения.
  }
}
